export class SessionExpiredError implements Error{
    name: string = "SessionExpiredError";
    message: string = "Tu sesión ha expirado";
    stack?: string | undefined;

}